import { useEffect } from "react";

export const META_TRAFFIC_SOURCE_KEY = "STOREFRONT_META_AD_SOURCE";
export const META_CAMPAIGN_ID_KEY = "STOREFRONT_META_CAMPAIGN_ID";

export function getStoredMetaTrafficSource(): "meta_ads" | null {
  return sessionStorage.getItem(META_TRAFFIC_SOURCE_KEY) as "meta_ads" | null;
}

export function getStoredMetaCampaignId(): string | null {
  return sessionStorage.getItem(META_CAMPAIGN_ID_KEY);
}

// utm_source=facebook + utm_medium=paid 조합으로 Meta 유료 광고 유입 판별
export default function useMetaTrafficSource(search: string): void {
  useEffect(() => {
    const params = new URLSearchParams(search);
    const utmSource = params.get("utm_source")?.toLowerCase();
    const utmMedium = params.get("utm_medium")?.toLowerCase();

    const isMetaAds = (utmSource === "facebook" || utmSource === "instagram") && Boolean(utmMedium?.includes("paid"));

    if (isMetaAds) {
      sessionStorage.setItem(META_TRAFFIC_SOURCE_KEY, "meta_ads");
      const campaignId = params.get("utm_campaign");
      if (campaignId) sessionStorage.setItem(META_CAMPAIGN_ID_KEY, campaignId);
    }
  }, [search]);
}
